<template>
	<div>
		<div class="box"></div>
		<div class="bnner">
			<img src="../../assets/images/cooperation.png" />
		</div>
		<div class="cooperation">
			<div class="title wow animate__backInDown animate__animated">
				<img src="../../assets/images/paptner.png" alt="" />
				<div class="hzkh">合作客户</div>
				<div style="display: flex; justify-content: center; margin-top: 15px">
					<div style="width: 44px; height: 5px; background-color: #12b1f9; display: flex"></div>
				</div>
			</div>
			<div class="logo wow animate__zoomIn animate__animated">
				<a href="https://www.jfjproductions.com/#" target="_blank" class="logoItem">
					<img src="../../assets//images/JFJ.png" alt="" style="width: 137px; height: 137px" />
					<p class="logoText">JFJ PRODUCTIONS</p>
				</a>
				<a href="https://www.ogilvy.com/cn/" target="_blank" class="logoItem itemtwo">
					<img
						src="../../assets//images/ogilvy.png"
						alt=""
						style="width: 169px; height: 169px; margin-top: -15px"
					/>
					<p class="logoText">奥美</p>
				</a>
				<a href="javascript:void(0)" class="logoItem itemthree">
					<img src="../../assets//images/chao.png" alt="" style="width: 127px; height: 107px" />
					<p class="logoText">汶潮文化</p>
				</a>
			</div>
		</div>
		<RequireMent></RequireMent>
	</div>
</template>
<script setup>
import WOW from "wow.js";
import { onMounted } from "vue";
const wowjsFn = () => {
	let wow = new WOW({
		boxClass: "wow", // default
		animateClass: "animate__animated", // default
		offset: 0, // default
		mobile: true, // default
		live: true, // default
	});
	wow.init();
	// wow.init();
};
onMounted(() => {
	// importScript();
	wowjsFn();
});
</script>
<style lang="less" scoped>
.bnner {
	width: 100%;
	// background-color: #30bafa;
	height: 240px;
	position: relative;
	background-image: url("../../assets//images//bnnderBG.png");
	background-size: contain;
	overflow: hidden;
	img {
		width: 1250px;
		position: absolute;
		left: 50%;
		height: 240px;
		margin-left: -625px;
	}
}
.box {
	height: 80px;
	width: 100%;
}
.cooperation {
	padding-top: 40px;
	background-image: url("../../assets//images/hezubg.png");
	width: 100%;
	height: 480px;
	.title {
		width: 240px;
		position: relative;
		// text-align: center;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		flex-direction: column;
		img {
			width: 240px;
			height: 40px;
		}
		.hzkh {
			position: absolute;
			top: 20px;
			left: 85px;
			font-size: 18px;
			color: #102d4d;
			font-weight: bold;
		}
	}
}
.logo {
	margin-top: 50px;
	display: flex;
	justify-content: center;
	.logoItem {
		display: flex;
		align-items: center;
		flex-direction: column;
		width: 298px;
		height: 223px;
		background-color: #fff;
		box-shadow: 0px 8px 10px rgba(209, 220, 225, 0.4);
		border: 1px solid #eee;
		cursor: pointer;
		position: relative;
		img {
			position: absolute;
			top: 18px;
		}
		.logoText {
			font-size: 18px;
			color: #000000;
			position: absolute;
			height: 39px;
			width: 181px;
			// left: 58.5px;
			top: 171px;
			z-index: 3;
			text-align: center;
		}
	}
	.itemtwo {
		margin: 0 80px;
	}
}
.logo .logoItem {
	transition: transform 0.3s ease;
}
.logo .logoItem:hover {
	transform: translateY(-5px);
}
@media screen and (min-width: 620px) and (max-width: 965px) {
	.logo .itemtwo {
		margin: 0 15px;
	}
}
@media screen and(min-width: 530px) and (max-width: 620px) {
	.cooperation .logo {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		justify-content: flex-start;
		.logoItem {
			flex: 1;
		}
		.itemtwo {
			margin: 0 15px;
		}
		// .itemthree {
		// 	margin-top: 15px;
		// }
	}
}
@media screen and(min-width: 470px) and (max-width: 530px) {
	.cooperation {
		height: 726px;
	}
	.cooperation .logo {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		justify-content: flex-start;
		.logoItem {
			width: 48%;
		}
		.itemtwo {
			margin-left: 15px;
			margin-right: 0;
		}
		.itemthree {
			margin-top: 15px;
		}
	}
}
@media (max-width: 470px) {
	.cooperation {
		height: 961px;
	}
	.cooperation .logo {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		justify-content: flex-start;
		padding: 0 10px;
		box-sizing: border-box;
		.logoItem {
			width: 100%;
		}
		.itemtwo {
			margin: 0;
			margin-top: 15px;
		}
		.itemthree {
			margin-top: 15px;
		}
	}
}
</style>
